/*eslint-disable*/
import { mapState } from 'vuex'

export default {
    methods: {
        isCourseAllow(type) {
            if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                return true;
            }
            if (!this.user || (!this.user.school && !(this.user.schools && this.user.schools.length))) {
                return false;
            }
            if (this.user.type === 'admin' && this.user.schools && this.user.schools.length > 1) {
                return this.user.schools.some(school => {
                    return school.courses.some(course => course.type === type)
                });
            }
            if (this.user.grades && this.user.grades.length >= 1) {
                return this.user.grades.some(grade => grade.course.type === type);
            }
            return this.user.school.courses.some(course => course.type === type);
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
        courseAllowMap () {
            return this.isCourseAllow('mental-arithmetic');
        },
        courseAllowDetective () {
            return this.isCourseAllow('fast-reading');
        }
    }
}
